import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private afAuth: AngularFireAuth, private router: Router) {}
  canActivate(): Observable<boolean> {
    return this.afAuth.authState.pipe(
      map(user => !!user), // Check if user exists
      //tap(isAuthenticated => console.log('Is Authenticated:', isAuthenticated)),
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          this.router.navigate(['/login']);
        }
      })
    );
  }
}
